var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditAboutMeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5362 19.2433L13.2784 18.4114C14.1892 17.3907 15.8232 17.5234 16.5574 18.6777C17.2413 19.753 18.727 19.9568 19.6753 19.1054L21.0208 17.8974M2.97852 19.4704L7.3445 18.5907C7.57628 18.544 7.78909 18.4298 7.95623 18.2626L17.7299 8.48356C18.1985 8.01471 18.1982 7.25472 17.7292 6.78626L15.6588 4.71818C15.19 4.24991 14.4304 4.25023 13.962 4.71889L4.18728 14.4989C4.02046 14.6658 3.90656 14.8782 3.85982 15.1095L2.97852 19.4704Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAboutMeIcon);
export default __webpack_public_path__ + "static/media/edit-about-me-icon.6ed50f990b3034c34f9dd954b3506d0a.svg";
export { ForwardRef as ReactComponent };